import React from 'react'
import Lottie from "lottie-react";
import error from "../../assets/404.json"
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

export const NotFoundPage= () => {
    const navigate = useNavigate()
  
  return (
    <div className='WidthFull h-screen flex justify-center flex-col items-center relative overflow-y-hidden '>
        <h1 className='text-4xl font-bold text-gray-600'>Opps Nothing Here</h1>
        <Lottie
            animationData={error}
            loop
            autoplay
            style={{ width: 850, height: 850 }}
          />
    <Button size='large' onClick={() => { navigate("/") }} className='absolute bottom-[10vh] translate-1/2 ' variant='contained'>Go Back</Button>
    </div>
  )
}
